module.exports = __webpack_public_path__ + "img/29.2a8c0ba8.png";